import React from 'react';
import mixpanel from 'mixpanel-browser';
import { Button } from '@mui/material';

import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

import { EDIT } from '../../constants/LoansCalculator';

export const MinimizeOrFullScreenButton = ({
  checkRates,
  isFullScreen,
  setIsFullScreen = () => {},
  filter = 'Rates Filter',
}) => {
  if (!checkRates) {
    return null;
  }

  return (
    <Button
      sx={{
        '&:hover': { backgroundColor: 'black', color: 'white' },
        m: 0,
        color: 'white',
        backgroundColor: 'black',
        float: 'right',
        borderRadius: '10px',
        width: '50px',
      }}
      onClick={() => {
        setIsFullScreen((prevState) => {
          mixpanel.track(filter, {
            fieldInput: 'Minimize or Full Screen',
            value: isFullScreen,
          });

          return !prevState;
        });
      }}
    >
      {' '}
      {isFullScreen ? <CloseFullscreenIcon /> : EDIT}
    </Button>
  );
};
